import React from 'react';
import { Container, Grid, Box, Typography } from '@mui/material';
import JordanPicture from '../images/IMG_0907 copy.webp';

const sections = [
  {
    title: 'Contributions to Weather Spotting',
    text: "Jordan's dedication to amateur radio is matched by his commitment to public safety. He serves as the District 5 Assistant Skywarn Coordinator and a net control station for East Tennessee SKYWARN. In these roles, he coordinates weather spotting activities, monitors severe weather conditions, and ensures timely and accurate communication during weather emergencies. His efforts contribute significantly to the safety and preparedness of the East Tennessee community.",
  },
  {
    title: 'Professional Software Development',
    text: "Beyond his amateur radio activities, Jordan is a skilled software developer with extensive experience in modern web technologies. He is proficient in React, Node.js, JavaScript, Python, VB.NET, and Java. Jordan's GitHub profile, under the username surgeNexus, showcases a variety of projects that reflect his technical expertise and innovative thinking.",
  },
  {
    title: 'Personal Interests',
    text: 'In addition to his professional and community activities, Jordan enjoys exploring new technologies, participating in ham radio contests, and engaging in outdoor activities. His multifaceted interests and commitment to lifelong learning drive his continuous growth and contributions in both the amateur radio and software development fields.',
  },
];

const About = () => {
  return (
    <Container maxWidth="lg">
      <Grid container spacing={4} sx={{ alignItems: 'center', mb: 6 }}>
        <Grid size={{ xs: 12, md: 7 }}>
          <Typography variant="h4" component="h2" gutterBottom>
            Early Life and Amateur Radio Beginnings
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Jordan Webb, known by his amateur radio callsigns NA4WX and K4AVG, has been an enthusiastic member of the
            amateur radio community since he was 12 years old. Starting his journey in 2002 with the callsign
            KI4AVG as a Technician class operator, Jordan quickly developed a passion for radio communication. Over
            the years, he has advanced through the licensing ranks, earning respect and recognition within the
            community.
          </Typography>
        </Grid>
        <Grid size={{ xs: 12, md: 5 }} sx={{ display: 'flex', justifyContent: 'center' }}>
          <Box
            component="img"
            src={JordanPicture}
            alt="Jordan Webb"
            sx={{ width: '100%', maxWidth: 300, borderRadius: 3, boxShadow: 3 }}
          />
        </Grid>
      </Grid>

      {sections.map((section) => (
        <Box key={section.title} sx={{ mb: 5 }}>
          <Typography variant="h5" component="h2" gutterBottom>
            {section.title}
          </Typography>
          <Typography variant="body1" color="text.secondary">
            {section.text}
          </Typography>
        </Box>
      ))}
    </Container>
  );
};

export default About;
